import React from "react";
import useAuth from "../hooks/useAuth";

export default function PublicPrivateRoute(publicElement: React.ReactElement, privateElement: React.ReactElement): React.ReactElement | null {
  const auth = useAuth();

  return auth.isAuthenticated ? privateElement : publicElement;
}
